import{d as e}from"./chunk-V5UYV5M6.js";import{c as t}from"./chunk-VC2YJD7D.js";import{m as o}from"./chunk-HBP5N4FR.js";o();var m=()=>e(t);export{m as a};
//# sourceMappingURL=chunk-2GJ67OFN.js.map
